module.exports = __webpack_public_path__ + "img/avatar4.aaff32fc.png";